import {
  Directive, inject,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef
} from '@angular/core';
import {filter, takeUntil, tap} from "rxjs/operators";
import {AuthUserService} from "../../@shared/services/auth/auth-user.service";
import {Subject} from "rxjs";

@Directive({
  selector: '[access]',
  standalone: true,
})
export class AccessDirective implements OnInit {
  readonly #templateRef: TemplateRef<any> = inject(TemplateRef);
  readonly #viewContainer: ViewContainerRef = inject(ViewContainerRef);
  readonly #authUserService: AuthUserService = inject(AuthUserService);
  private readonly destroyed$: Subject<void> = new Subject<void>();

  @Input('access') roles!: string[] | undefined;

  ngOnInit() {
    this.#authUserService.user$
      .pipe(
        takeUntil(this.destroyed$),
        tap(() => this.#viewContainer.clear()),
        filter((user: any) => {
          return user
            ? user.roles.some((role: string) => this.roles?.includes(role))
            : false
        }))
      .subscribe(() => this.#viewContainer.createEmbeddedView(this.#templateRef));
  }

}
